import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CheckCircle2Icon, Loader2Icon, MailIcon, PhoneIcon } from "lucide-react";
type Status = "idle" | "loading" | "success" | "error";
const needOptions = ["Investir dans l'immobilier", "Placer son argent", "Payer moins d'impôts", "Préparer sa retraite", "Protéger sa famille", "Autre"];
export function ContactCta() {
  const [status, setStatus] = useState<Status>("idle");
  const [error, setError] = useState("");
  const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const data = new FormData(e.currentTarget);
    const email = String(data.get("email") ?? "");
    const name = String(data.get("name") ?? "");
    if (!name.trim() || !/^\S+@\S+\.\S+$/.test(email)) {
      setStatus("error");
      setError("Merci d'indiquer votre nom et une adresse e-mail valide.");
      return;
    }
    setError("");
    setStatus("loading");
    window.setTimeout(() => setStatus("success"), 900);
  };
  const fieldClass = "w-full rounded-xl border border-line bg-white px-4 py-3 text-ink placeholder:text-muted/70 focus:border-brand focus:outline-none focus:ring-2 focus:ring-brand/20";
  return <section id="contact" className="w-full bg-cream py-24 lg:py-32" data-id="element-1" data-mp="19t9us02cdc9">
      <div className="mx-auto grid max-w-7xl gap-14 px-6 lg:grid-cols-12 lg:px-10" data-id="element-2" data-mp="68mmki7j00bd">
        <div className="lg:col-span-5" data-id="element-3" data-mp="35o1hrxow7wox">
          <h2 className="font-serif text-4xl font-medium leading-tight text-ink lg:text-5xl" data-id="element-4" data-mp="35p2vyb17gzav">
            Parlons de votre patrimoine
          </h2>
          <p className="mt-6 text-lg leading-relaxed text-muted" data-id="element-5" data-mp="3eog512lf3lv2">
            Un premier échange sans engagement pour faire le point sur votre situation et vos objectifs.
          </p>
          <ul className="mt-10 space-y-4" data-id="element-6" data-mp="2lzip364oi15h">
            <li data-id="element-7" data-mp="2lyh8yn8t2ogw">
              <a href="tel:+33100000000" className="flex items-center gap-3 text-ink transition-colors duration-150 hover:text-brand" data-id="element-8" data-mp="2lyzfccp6mj2j">
                <PhoneIcon className="h-5 w-5 text-brand" data-id="element-9" data-mp="3u9j5epqh2997" />
                01 00 00 00 00
              </a>
            </li>
            <li data-id="element-10" data-mp="3pay2ujnqzdhl">
              <a href="mailto:contact@success-capital.com" className="flex items-center gap-3 text-ink transition-colors duration-150 hover:text-brand" data-id="element-11" data-mp="3p9d7irtlzqio">
                <MailIcon className="h-5 w-5 text-brand" data-id="element-12" data-mp="2utw93zxkrgf" />
                contact@success-capital.com
              </a>
            </li>
          </ul>
        </div>

        <div className="rounded-2xl bg-white p-8 lg:col-span-6 lg:col-start-7 lg:p-10" data-id="element-13" data-mp="3bb6tiw86el9x">
          <AnimatePresence mode="wait" data-id="element-14" data-mp="36cvjolhvsarp">
            {status === "success" ? <motion.div key="success" initial={{
            opacity: 0,
            scale: 0.96
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.2,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex min-h-[360px] flex-col items-start justify-center" role="status" data-id="element-15" data-mp="3kcei2mkw47qt">
                <CheckCircle2Icon className="h-10 w-10 text-brand" data-id="element-16" data-mp="1331s26jleegl" />
                <h3 className="mt-6 font-serif text-3xl font-medium text-ink" data-id="element-17" data-mp="131qnw5m8j4oy">Merci, c'est noté.</h3>
                <p className="mt-3 text-muted" data-id="element-18" data-mp="175yfcak2uyqv">Un conseiller vous recontacte sous 48 heures ouvrées.</p>
                <button type="button" onClick={() => setStatus("idle")} className="mt-8 text-sm font-semibold text-brand underline-offset-4 hover:underline" data-id="element-19" data-mp="t6yqb1snkhu6">
                  Envoyer une autre demande
                </button>
              </motion.div> : <motion.form key="form" initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} exit={{
            opacity: 0
          }} transition={{
            duration: 0.15
          }} onSubmit={handleSubmit} noValidate className="grid gap-5" data-id="element-20" data-mp="1c48c2plga7el">
                <div className="grid gap-5 sm:grid-cols-2" data-id="element-21" data-mp="29kf40jutewxl">
                  <label className="grid gap-2 text-sm font-medium text-ink" data-id="element-22" data-mp="kxjgsu35w6dz">
                    Nom complet
                    <input name="name" autoComplete="name" className={fieldClass} placeholder="Jean Dupont" data-id="element-23" data-mp="gumryln13e1l" />
                  </label>
                  <label className="grid gap-2 text-sm font-medium text-ink" data-id="element-24" data-mp="bypc0gfog9pc">
                    E-mail
                    <input name="email" type="email" autoComplete="email" className={fieldClass} placeholder="jean@exemple.fr" data-id="element-25" data-mp="6zmf5j9up9sg" />
                  </label>
                </div>
                <label className="grid gap-2 text-sm font-medium text-ink" data-id="element-26" data-mp="zmpci82sjeh4">
                  Votre besoin
                  <select name="need" className={fieldClass} defaultValue={needOptions[0]} data-id="element-27" data-mp="utmixzy0k50x">
                    {needOptions.map(o => <option key={o} data-id="element-28" data-mp="1nbi3dq4k2w4v">{o}</option>)}
                  </select>
                </label>
                <label className="grid gap-2 text-sm font-medium text-ink" data-id="element-29" data-mp="1ikru41t0e94w">
                  Message <span className="sr-only" data-id="element-30" data-mp="1pwpsiv3wgpgv">(facultatif)</span>
                  <textarea name="message" rows={4} className={fieldClass} placeholder="Quelques mots sur votre projet (facultatif)" data-id="element-31" data-mp="1pyaqkupfaqjh" />
                </label>
                {status === "error" && <p role="alert" className="text-sm text-red-700" data-id="element-32" data-mp="1zwglutgq4yfd">
                    {error}
                  </p>}
                <button type="submit" disabled={status === "loading"} className="mt-2 inline-flex items-center justify-center gap-2 rounded-full bg-ink px-7 py-3.5 text-sm font-semibold text-white transition-colors duration-150 hover:bg-brand disabled:opacity-70" data-id="element-33" data-mp="28vloaavepbwt">
                  {status === "loading" && <Loader2Icon className="h-4 w-4 animate-spin" data-id="element-34" data-mp="2nm1btwbaovy5" />}
                  {status === "loading" ? "Envoi en cours…" : "Être rappelé par un conseiller"}
                </button>
              </motion.form>}
          </AnimatePresence>
        </div>
      </div>
    </section>;
}